<template>
    <div class="page-user-lsit">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺管理</div>
            <div class="breadcrumb-item">APP推薦模塊</div>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isSubmiting">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>
            <div class="pg-toolbar">
                <div class="pg-btn-wrap">
                    <div class="pg-btn style1" @click="handleToAdd(0)">新增</div>
                </div>
            </div>
            <Table size="small"
                   no-data-text="暫無數據"
                   border
                   maxHeight="680"
                   :columns="table.column"
                   :data="table.data">
                
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEditModal(row)">修改模塊</div>
                        <div class="pg-btn style3" @click="handleEdit(row)">修改图片</div>
                        <div class="pg-btn style1" @click="handleDelete(row)">删除</div>
                    </div>
                </template>
                
                <template slot="status" slot-scope="{row,index}">
                        <Switchs true-color="#51f4a9" v-model="row.status" @on-change="statusChange(row)"/>
                </template>

            </Table>
            

        </div>
        <Modal
            v-model="showModal"
            title="新增推荐模块"
            @on-ok="ok">
                <Row>
                    <Col span="24" push="5">
                        <Form :label-width="150">
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>廣告区域</span>
                                        </div>

                                        <Input v-model="form.name" style="width:100%" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>
                            
                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>狀態</span>
                                        </div>
                                        <RadioGroup v-model="form.status">
                                            <Radio label="1">
                                                <span>是</span>
                                            </Radio>
                                            <Radio label="0">
                                                <span>否</span>
                                            </Radio>
                                        </RadioGroup>
                                    </FormItem>
                                </Col>
                            </Row>

                            <Row :gutter="15">
                                <Col span="14">
                                    <FormItem>
                                        <div slot="label" class="form-label">
                                            <em class="red">* </em>
                                            <span>排序</span>
                                        </div>
                                        <Input v-model.number="form.sort" max="100" min="1" placeholder="1-100" clearable/>
                                    </FormItem>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                </Row>
            
        </Modal>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                srcList: [],
                isSubmiting: false,
                status: false, // 是否開啓
                showModal: false,
                editAddType: 0,
                table: {
                    column: [
                        {
                            title: '廣告区域',
                            key: 'name',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '是否開啓',
                            key: 'status',
                            align: 'center',
                            slot: 'status',
                            minWidth: 80
                        },{
                            title: '排序',
                            key: 'sort',
                            align: 'center',
                            minWidth: 80
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            minWidth: 150
                        },
                    ],
                    data: []
                },
                form: {
                    id: '',
                    name: '',
                    sort: 1,
                    status: '0',
                },
            };
        },
        activated() {
        
        },
        created() {
            this.getList();
        },
        methods: {
    
            // 新增   appRecommendedAdd 修改 appRecommendedSet
            ok() {
                let url;
                this.editAddType === 0 ? (url = this.$Api.appRecommendedAdd) : (url = this.$Api.appRecommendedSet)
                let form = this.form
                this.$Rq.requestAuth({
                    url,
                    method: 'post',
                    data: form
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showSuccess(res.msg);
                    if (res.code === 0) {
                        this.removeForm();
                        this.getList();
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            
            // 开启 关闭
            statusChange(item) {
                console.log(item)
                let id = item.id, status = (item.status ? '1' : '0');
              
                this.isSubmiting = true;
            
                this.$Rq.requestAuth({
                    url: this.$Api.appRecommendedSetStatus,
                    method: 'post',
                    data: {
                        id,
                        type: 1,
                        status
                    }
                }).then((res) => {
                    this.isSubmiting = false;
                    this.$Utils.showSuccess(res.msg);
                    if (res.code === 0) {
                        this.getList();
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            
            // 列表
            getList() {
                this.isSubmiting = true;
                this.$Rq.requestAuth({
                    url: this.$Api.appRecommendedManageList,
                    method: 'get',
                }).then((res) => {
                    this.isSubmiting = false;
                    if (res.code == 0) {
                        this.table.data = res.data.data.map(item => {
                            item.status = item.status == 1
                            return item
                        });
                    } else {
                        this.showTipInfo(res.msg);
                    }
                }).catch((err) => {
                    this.isSubmiting = false;
                });
            },
            
            // 删除
            handleDelete(item) {
                let id = item.id;
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () => {
                        this.isSubmiting = true;
                        this.$Rq.requestAuth({
                            url: this.$Api.appRecommendedMdel,
                            method: 'post',
                            data: {id}
                        }).then((res) => {
                            this.isSubmiting = false;
                            this.$Utils.showSuccess(res.msg);
                            if (res.code == 0) {
                                this.getList();
                            }
                        }).catch((err) => {
                            this.isSubmiting = false;
                            this.$Utils.showSuccess('网络异常');
                        });
                    }
                });
            },
            
            // 弹出 修改
            handleEditModal(row) {
                for (const formKey in this.form) {
                    this.form[formKey] = row[formKey]
                }
                this.form['status'] = row['status'] ? '1' : '0'
                this.handleToAdd(1)
            },
    
            // 弹出新增
            handleToAdd(type) {
                // this.$router.push({path: '/recommendedAdd'});
                type === 0 && this.removeForm();
                this.editAddType = type
                this.showModal = true;
            },
            
            // 清空form
            removeForm() {
                for (const formKey in this.form) {
                    this.form[formKey] = ''
                }
                this.form['status'] = '0'
            },
            
            // 修改子项
            handleEdit(item) {
                this.$router.push({path: '/recommendedAdd?id=' + item.id})
            },
        }
    };
</script>

<style lang="scss" scoped>
    @import 'recommendedManage.scss';
</style>
